/* OCEA landing — общий рантайм: выбранный тариф, прямой чекаут, плавный скролл, in-view. Секции — в своих {% javascript %}. */
(function () {
  'use strict';
  if (window.Ocea) return;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var state = { plan: null };

  /* Тариф: единственный источник — форма #ocea-offer-form (радио name="id"); секция офера зовёт setPlan, остальные слушают 'ocea:plan'. */
  function setPlan(detail) {
    state.plan = detail;
    document.dispatchEvent(new CustomEvent('ocea:plan', { detail: detail }));
  }
  function getPlan() { return state.plan; }

  /* Прямой чекаут: cart permalink /cart/{variant}:1 (+ utm → attributes). Без варианта — скролл к оферу. */
  function trackingParams() {
    var params = [];
    try {
      var q = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'].forEach(function (k) {
        var v = q.get(k); if (v) params.push('attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(v));
      });
    } catch (e) {}
    return params;
  }
  function checkout(variantId, sellingPlan) {
    var id = variantId || (state.plan && state.plan.variantId);
    if (!id || !/^\d+$/.test(String(id))) { scrollTo('#offer'); return false; }
    var params = trackingParams();
    if (sellingPlan) params.push('selling_plan=' + encodeURIComponent(sellingPlan));
    window.location.assign('/cart/' + id + ':1' + (params.length ? '?' + params.join('&') : ''));
    return true;
  }

  /* Скролл к якорю с поправкой на навбар (88px) */
  function scrollTo(target) {
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return;
    var bar = document.querySelector('[data-ocea-navbar]');
    var offset = bar ? bar.offsetHeight : 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED.matches ? 'auto' : 'smooth' });
  }

  /* Кнопки с data-ocea-checkout — везде сразу чекаут выбранного тарифа; ссылки data-ocea-scroll — плавный скролл */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ocea-checkout]');
    if (a) { e.preventDefault(); a.setAttribute('aria-busy', 'true'); if (!checkout()) a.removeAttribute('aria-busy'); return; }
    var s = e.target.closest('[data-ocea-scroll]');
    if (s) { var href = s.getAttribute('href') || s.dataset.oceaScroll; if (href && href.charAt(0) === '#' && document.querySelector(href)) { e.preventDefault(); scrollTo(href); } }
  });

  /* Появление в вьюпорте: один раз, когда видна доля threshold (по умолчанию 0.25).
     Только isIntersecting не годится: наблюдатель зовёт колбэк и на первом пикселе (смена isIntersecting), порог при этом не пройден */
  function onEnter(el, cb, threshold, rootMargin) {
    if (!('IntersectionObserver' in window)) { cb(el); return; }
    var t = threshold == null ? 0.25 : threshold;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio >= t) { io.unobserve(en.target); cb(en.target); } });
    }, { threshold: t, rootMargin: rootMargin || '0px' });
    io.observe(el);
  }

  /* Ленты с горизонтальным скроллом: lazy-картинки за краем экрана сами не грузятся — грузим все, когда блок в 800px */
  function eagerNear(el) {
    onEnter(el, function () { el.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; }); }, 0, '800px 0px');
  }

  /* «Назад» из чекаута: страница из bfcache возвращается с кнопками в состоянии «занято» (полупрозрачные, не нажимаются) — снимаем */
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[aria-busy="true"]').forEach(function (el) { el.removeAttribute('aria-busy'); });
  });

  window.Ocea = { setPlan: setPlan, getPlan: getPlan, checkout: checkout, scrollTo: scrollTo, onEnter: onEnter, eagerNear: eagerNear, reduced: REDUCED };
})();
